import { ImageMarkerImageSection } from 'components/minute/sidebar/MarkerSidebar/ImageMarkerSidebar/ImageMarkerImageSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IImageV2WorldMarker;
}

export const ImageMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_ImageMarkerSidebar className={props.className}>
            <ImageMarkerImageSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_ImageMarkerSidebar>
    );
};

const S_ImageMarkerSidebar = styled.div``;
